<template>
  <div class="inner">
    <table id="shoppingCartProductItemsTable">
      <thead>
        <tr>
          <th>{{ $t('cart.tableHeaderProduct') }}</th>
          <th>{{ $t('cart.tableHeaderEngravedId') }}</th>
          <th>{{ $t('cart.tableHeaderDateEffective') }}</th>
          <th>{{ $t('cart.tableHeaderVatPercentage') }}</th>
          <th>{{ $t('cart.tableHeaderVatAmount') }}</th>
          <th>{{ $t('cart.tableHeaderAmount') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="cartItem in cartProductItems">
          <tr :key="cartItem.orderItemId">
            <td data-title="Product">
              <a href="#" class="remove-icon" @click.prevent="openRemoveModal(cartItem)">
                {{ $t('generic.delete') }} {{ cartItem.productTitle }} {{ cartItem.engravedId }}
              </a>
              {{ cartItem.productTitle }}
            </td>
            <td data-title="Kaartnummer">
              {{ cartItem.engravedId | engravedId }}
            </td>
            <td data-title="Ingangsdatum">
              {{ $d(cartItem.dateEffective, 'date') }}
            </td>
            <td data-title="BTW %">
              {{ cartItem.vatPercentage }}
            </td>
            <td data-title="BTW">
              {{ $n(cartItem.vatAmount.amount, 'currency') }}
            </td>
            <td data-title="Prijs">
              {{ $n(cartItem.amountWithVat.amount, 'currency') }}
            </td>
          </tr>
          <tr v-if="cartItem.discountAmount.amount < 0" :key="`${cartItem.orderItemId}-discount`" class="discount">
            <td>{{ $t('cart.discount') }}</td>
            <td colspan="4">&nbsp;</td>
            <td>{{ $n(cartItem.discountAmount.amount, 'currency') }}</td>
          </tr>
          <tr v-if="cartItem.combiDealDiscountAmount.amount < 0" :key="`${cartItem.orderItemId}-combi-deal`" class="discount combi-deal">
            <td>{{ $t('cart.combiDealDiscount') }}</td>
            <td colspan="4">&nbsp;</td>
            <td>{{ $n(cartItem.combiDealDiscountAmount.amount, 'currency') }}</td>
          </tr>
        </template>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="3">&nbsp;</td>
          <td>{{ $t('cart.total') }}</td>
          <td>{{ $n(totalVatAmount.amount, 'currency') }}</td>
          <td>{{ $n(totalAmountWithVat.amount, 'currency') }}</td>
        </tr>
      </tfoot>
    </table>

    <v-modal v-if="removeModalVisible"
             id="cartItemRemoveConfirmModal"
             @close="closeRemoveModal()">
      <h2>{{ $t('cart.removeModalTitle') }}</h2>
      <p>{{ $t('cart.removeModalIntro') }}</p>
      <fieldset class="submit">
        <button id="cartItemRemoveConfirmButtonYes"
                class="yes"
                @click.prevent="doRemoval()">
          {{ $t('generic.yes') }}
        </button>
        <a id="cartItemRemoveConfirmButtonNo"
           href="#"
           class="cancel"
           @click.prevent="closeRemoveModal()">
          {{ $t('generic.no') }}
        </a>
      </fieldset>
    </v-modal>
  </div>
</template>

<script>
import VModal from './modals/Modal'
import { Price } from '../types/price'

export default {
  components: {
    VModal
  },
  props: {
    cartProductItems: {
      type: Array,
      required: true
    },
    totalAmountWithVat: {
      type: Price,
      required: false,
      default: 0
    },
    totalVatAmount: {
      type: Price,
      required: false,
      default: 0
    }
  },
  data () {
    return {
      removeModalVisible: false,
      cartItemSelectedForRemoval: null
    }
  },
  computed: {},
  methods: {
    openRemoveModal (cartItem) {
      this.cartItemSelectedForRemoval = cartItem
      this.removeModalVisible = true
    },
    closeRemoveModal () {
      this.cartItemSelectedForRemoval = null
      this.removeModalVisible = false
    },
    doRemoval () {
      this.removeModalVisible = false
      this.$emit('cartItemRemoved', this.cartItemSelectedForRemoval)
      this.cartItemSelectedForRemoval = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cart.vue